export const SELECT_FROM_LIST = 'select';
export const FILE_UPLOAD = 'fileUpload';
